import { create } from 'zustand';

type State = {
    activeSection: number;
};

type Actions = {
    actions: {
        setActiveSection: (state: State['activeSection']) => void;
    };
};

export const useActiveSectionStore = create<State & Actions>((set) => ({
    activeSection: 0,
    actions: {
        setActiveSection: (newState) => set(() => ({ activeSection: newState })),
    },
}));

export const useActiveSectionValue = () => useActiveSectionStore((state) => state.activeSection);
export const useActiveSectionSetState = () => useActiveSectionStore((state) => state.actions.setActiveSection);
